<template>
  <div class="mask">
    <div class="modal">
      <div class="close"
           v-on:click="onDismiss"></div>

      <section class="teacher">
        <el-avatar class="photo"
                   :src="teacher.photo"
                   :size="getTeacherPhotoSize()" />
        <div class="info">
          <div class="name">{{ teacher.name }}</div>
          <img class="divider"
               src="../assets/teacher-divider.svg" />
          <pre class="intro">{{ teacher.resume }}</pre>
        </div>
      </section>
      <Divider />
      <section class="comments">
        <h4>學生評價</h4>
        <div class="comment"
             v-for="comment in teacher.comments"
             :key="comment.id">
          <el-avatar class="comment-photo"
                     :src="comment.photo"
                     :size="getCommentPhotoSize()" />
          <pre>{{ comment.comment }}</pre>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import Divider from "@/components/Divider.vue";

export default {
  components: {
    Divider
  },
  props: {
    teacher: {
      id: Number,
      school_level: String,
      subject: String,
      name: String,
      photo: String,
      resume: String,
      comments: Array
    },
    onDismiss: Function
  },
  methods: {
    getTeacherPhotoSize() {
      switch (this.$mq) {
        case "mobile":
        case "tablet":
        case "laptop":
          return 100;
        default:
          return 250;
      }
    },
    getCommentPhotoSize() {
      switch (this.$mq) {
        case "mobile":
        case "tablet":
        case "laptop":
          return 60;
        default:
          return 90;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.mask {
  position: fixed;
  z-index: 999;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 90px;
  box-sizing: border-box;
  top: 0;
  left: 0;
  overflow: scroll;
}

.modal {
  position: relative;
  background-color: white;
  border: 6px solid #f1d85b;
  border-radius: 33px;
  max-width: 1007px;
  margin: auto;
  padding: 40px 70px;
  box-sizing: border-box;

  pre {
    white-space: pre-wrap;
    word-break: break-all;
  }

  .close {
    position: absolute;
    top: -25px;
    right: -25px;
    width: 80px;
    height: 80px;
    background-color: #f1d85b;
    border-radius: 100%;
    cursor: pointer;

    &:before,
    &:after {
      content: "";
      display: block;
      width: 7px;
      height: 52px;
      position: absolute;
      background-color: #63abcd;
      top: calc(40px - 26px);
      left: calc(40px - 3.5px);
      border-radius: 7px;
    }

    &:before {
      transform: rotate(45deg);
    }
    &:after {
      transform: rotate(-45deg);
    }
  }

  .teacher {
    display: grid;
    grid-template-columns: auto 1fr;
    grid-gap: 20px;
    margin-bottom: 50px;

    .info {
      .name {
        color: #134563;
        font-size: 20px;
        letter-spacing: 2.5px;
        font-weight: bold;
      }
      .divider {
        display: block;
        margin-bottom: 5px;
      }
      .intro {
        color: #595959;
        letter-spacing: 2px;
        font-weight: bold;
        font-size: 16px;
      }
    }
  }

  .comments {
    margin-top: 20px;

    h4 {
      font-size: 20px;
      font-weight: bold;
      letter-spacing: 2.5px;
      color: #595959;
    }

    .comment {
      display: grid;
      grid-template-columns: auto 1fr;
      grid-gap: 20px;
      padding: 15px 0;
      border-bottom: 1px solid #979797;

      p {
        font-size: 14px;
        line-height: 21px;
        letter-spacing: 1.75px;
        color: #595959;
      }
    }
  }
}

@media (max-width: 1023px) {
  .mask {
    padding: 23px 12px !important;
  }

  .modal {
    padding: 20px 18px !important;
  }

  .close {
    width: 40px !important;
    height: 40px !important;
    top: -15px !important;
    right: -12px !important;

    &:before,
    &:after {
      width: 4px !important;
      height: 26px !important;

      top: calc(50% - 13px) !important;
      left: calc(50% - 2px) !important;
    }
  }

  .teacher {
    display: flex !important;
    flex-direction: column;
    margin-bottom: 9px !important;

    .photo {
      margin: auto;
    }

    .name {
      text-align: center;
      font-size: 16px !important;
    }

    .divider {
      margin: 0 auto 9px !important;
    }

    .intro {
      font-size: 14px !important;
    }
  }

  .comments {
    margin-top: 9px !important;

    h4 {
      font-size: 16px !important;
    }

    .comment {
      font-size: 12px !important;
      font-weight: bold !important;

      &:last-child {
        border-bottom: none !important;
      }
    }
  }
}
</style>
